import { FiltroDeclaracionJurada } from "../models/filtroDeclaracionJurada";
import { generarDeclaracionJurada } from "../services/servicesDeclaracionJurada";

export default function UseDeclaracionJurada(){

    const generarDeclaracion = async (e: FiltroDeclaracionJurada) => {
        const response = await generarDeclaracionJurada(e);
        return response;
    }

    return { generarDeclaracion }
}